"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "select_space_cont" };
const _hoisted_2 = {
    key: 0,
    class: "wf-select-space"
};
const _hoisted_3 = {
    key: 1,
    class: "nes-container is-rounded"
};
const _hoisted_4 = { class: "nes-text is-warning" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_confirm_dialog = (0, vue_1.resolveComponent)("confirm-dialog");
    const _component_go_to_map = (0, vue_1.resolveComponent)("go-to-map");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_confirm_dialog, {
            message: "Place your tile here?",
            enableDontShowAgainCheckbox: true,
            ref: "confirmation",
            onAccept: _ctx.confirmPlacement,
            onDismiss: _ctx.cancelPlacement,
            onHide: _ctx.hideDialog
        }, null, 8, ["onAccept", "onDismiss", "onHide"]),
        (_ctx.showtitle)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)) + " ", 1),
                (0, vue_1.createVNode)(_component_go_to_map, { playerinput: _ctx.playerinput }, null, 8, ["playerinput"])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.warning)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_4, [
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.warning), 1)
                ])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createVNode)(_component_go_to_map, { playerinput: _ctx.playerinput }, null, 8, ["playerinput"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
